import Button from '../Button';
import { AlertDialogWrapper } from './AlertDialog';

export * from './AlertDialog';

export const ButtonWithDialog = AlertDialogWrapper(Button);
export default AlertDialogWrapper;
